var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",class:{ 'invoice-index-container': _vm.version >= 1 }},[_c('listing-v2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }